import React, { useState } from "react";
import Wrapper from "../components/Wrapper";
import { useNavigate } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { translations } from "../langauge";
import MobileBottomMenu from "../components/MobileBottomMenu";

const AboutUs = () => {
  const { lang } = useLang();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("the-shift");

  const sideNavItems = [
    { id: "go-back", title: translations[lang].go_back, href: "/", isBack: true },
    { id: "the-shift", title: translations[lang].the_shift, active: true },
    { id: "why-we-exist", title: translations[lang].why_we_exist },
    { id: "our-virtues", title: translations[lang].our_virtues },
    { id: "the-stack", title: translations[lang].the_stack },
  ];

  const sectionTitles = {
    "the-shift": translations[lang].the_shift,
    "why-we-exist": translations[lang].why_we_exist,
    "our-virtues": translations[lang].our_virtues,
    "the-stack": translations[lang].the_stack,
  };

  const SECTION_IDS = ["the-shift", "why-we-exist", "our-virtues", "the-stack"];
  const sectionIndex = SECTION_IDS.indexOf(activeSection);
  const safeSectionIndex = sectionIndex >= 0 ? sectionIndex : 0;

  const handlePrevSection = () => {
    const prevIndex = (safeSectionIndex - 1 + SECTION_IDS.length) % SECTION_IDS.length;
    setActiveSection(SECTION_IDS[prevIndex]);
  };
  const handleNextSection = () => {
    const nextIndex = (safeSectionIndex + 1) % SECTION_IDS.length;
    setActiveSection(SECTION_IDS[nextIndex]);
  };

  return (
    <Wrapper>
      <div className="row">
        <div className="col-lg-3 col-md-4 col-4 rightSideDivParent">
          <div className="rightSideDiv">
            <div className="navbarDiv">
              <ul>
                {sideNavItems.map((item) => (
                  <li key={item.id}>
                    {item.isBack ? (
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/");
                        }}
                        style={{
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <img
                          alt="go back"
                          src="./images/left-arrow.png"
                          style={{
                            marginRight: lang === "en" ? "15px" : 0,
                            marginLeft: lang === "ar" ? "15px" : 0,
                            height: "20px",
                            width: "auto",
                            transform: lang === "ar" ? "rotate(180deg)" : undefined,
                          }}
                        />
                        {item.title}
                      </a>
                    ) : (
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveSection(item.id);
                        }}
                        className={activeSection === item.id ? "active" : ""}
                        style={{ textAlign: lang === "ar" ? "right" : "left" }}
                      >
                        {item.title}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="col-lg-9 col-md-8 col-8 contentDivParent">
          <div className="contentDiv">
            {activeSection === "the-shift" && (
              <section
                id="the-shift"
                className="aboutSection"
                style={{ textAlign: lang === "ar" ? "right" : "left" }}
              >
                <h2 className="aboutSectionTitle">
                  {translations[lang].the_shift}
                </h2>
                <p className="commonpara">
                  {translations[lang].about_para_1}
                </p>
                <p className="commonpara">
                  {translations[lang].about_para_3}
                </p>
              </section>
            )}
            {activeSection === "why-we-exist" && (
              <section
                id="why-we-exist"
                className="aboutSection"
                style={{ textAlign: lang === "ar" ? "right" : "left" }}
              >
                <h2 className="aboutSectionTitle">
                  {translations[lang].why_we_exist}
                </h2>
                <h3 className="aboutFeatureTitle">
                  {translations[lang].built_by_designers}
                </h3>
                <p className="commonpara">
                  {translations[lang].why_para_1}
                </p>
                {translations[lang].why_para_2 && (
                  <p className="commonpara">
                    {translations[lang].why_para_2}
                  </p>
                )}
                <h3 className="aboutFeatureTitle">
                  {translations[lang].the_difference_shows}
                </h3>
                {translations[lang].conversion_focused && (
                  <>
                    <h4 className="aboutFeatureTitle">
                      {translations[lang].conversion_focused}
                    </h4>
                    <p className="commonpara">
                      {translations[lang].why_para_3}
                    </p>
                  </>
                )}
                {!translations[lang].conversion_focused && (
                  <p className="commonpara">
                    {translations[lang].why_para_3}
                  </p>
                )}
                {translations[lang].mobile_first_ux && (
                  <>
                    <h4 className="aboutFeatureTitle">
                      {translations[lang].mobile_first_ux}
                    </h4>
                    <p className="commonpara">
                      {translations[lang].why_para_4}
                    </p>
                  </>
                )}
                {translations[lang].clean_scaling && (
                  <>
                    <h4 className="aboutFeatureTitle">
                      {translations[lang].clean_scaling}
                    </h4>
                    <p className="commonpara">
                      {translations[lang].why_para_5}
                    </p>
                  </>
                )}
                <h3 className="aboutFeatureTitle">
                  {translations[lang].we_fix_the_friction}
                </h3>
                <p className="commonpara">
                  {translations[lang].why_para_6}
                </p>
                <p className="commonpara">
                  {translations[lang].why_para_7_highlight}
                </p>
              </section>
            )}
            {activeSection === "our-virtues" && (
              <section
                id="our-virtues"
                className="aboutSection"
                style={{ textAlign: lang === "ar" ? "right" : "left" }}
              >
                <h2 className="aboutSectionTitle">
                  {translations[lang].our_virtues}
                </h2>
                <p className="commonpara">
                  {translations[lang].virtues_intro}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].virtue_design_first}
                </h4>
                <p className="commonpara">
                  {translations[lang].virtue_design_para}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].virtue_speed}
                </h4>
                <p className="commonpara">
                  {translations[lang].virtue_speed_para}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].virtue_commission}
                </h4>
                <p className="commonpara">
                  {translations[lang].virtue_commission_para}
                </p>
                <h4 className="aboutVirtueTitle">
                  {translations[lang].virtue_precision}
                </h4>
                <p className="commonpara">
                  {translations[lang].virtue_precision_para}
                </p>
              </section>
            )}
            {activeSection === "the-stack" && (
              <section
                id="the-stack"
                className="aboutSection"
                style={{ textAlign: lang === "ar" ? "right" : "left" }}
              >
                <h2 className="aboutSectionTitle">
                  {translations[lang].the_stack}
                </h2>
                <h4 className="aboutFeatureTitle">
                  {translations[lang].stack_frontend}
                </h4>
                <p className="commonpara">
                  {translations[lang].stack_frontend_para}
                </p>
                <h4 className="aboutFeatureTitle">
                  {translations[lang].stack_transaction}
                </h4>
                <p className="commonpara">
                  {translations[lang].stack_transaction_para}
                </p>
                <h4 className="aboutFeatureTitle">
                  {translations[lang].stack_own_data}
                </h4>
                <p className="commonpara">
                  {translations[lang].stack_own_data_para}
                </p>
                <h4 className="aboutFeatureTitle">
                  {translations[lang].stack_direct}
                </h4>
                <p className="commonpara">
                  {translations[lang].stack_direct_para}
                </p>
                <div className="aboutFooter">
                  <p className="aboutFooterText">
                    {translations[lang].stack_footer_1}
                  </p>
                  <p className="aboutFooterText">
                    {translations[lang].stack_footer_2}
                  </p>
                  <p className="aboutFooterText">
                    {translations[lang].stack_footer_3}
                  </p>
                </div>
              </section>
            )}
          </div>
        </div>
      </div>
      <MobileBottomMenu
        title={sectionTitles[activeSection] ?? translations[lang].the_shift}
        withTabs
        sectionIndex={safeSectionIndex}
        sectionCount={SECTION_IDS.length}
        onPrev={handlePrevSection}
        onNext={handleNextSection}
      />
    </Wrapper>
  );
};

export default AboutUs;
